export default "__VITE_ASSET__lXdeyVfz__"